export default __webpack_public_path__ + "static/screenFifthSectionEnBig-f40de5d62c76301b13db6699d110870c.webp";